import { WithStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green, grey } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { isNull } from 'util';
import { ITargetSetParam } from '../actions/skillMap';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import SkillMapScenarioFactory from '../scenario/SkillMapScenarioFactory';

const styles = (theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
		},
		baseRow: {
			alignItems: 'center',
			display: 'flex',
			flexDirection: 'row',
		},
		buttonProgress: {
			color: green[500],
			left: '50%',
			marginLeft: -12,
			marginTop: -12,
			position: 'absolute',
			top: '50%',
		},
		dataCol: {
			minWidth: '400px',
			padding: '0px 10px',
		},
		dataColBorder: {
			borderTopColor: grey[300],
			borderTopStyle: 'solid',
			borderTopWidth: '2px',
		},
		dataLabel: {
			cursor: 'default',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			wordBreak: 'break-all',
		},
		paper: {
			display: 'flex',
			flexDirection: 'column',
		},
		root: {
			flexGrow: 1,
			position: 'relative',
		},
		title: {
			flex: 1,
			marginLeft: theme.spacing(2),
		},
		titleCol: {
			backgroundColor: grey[300],
			height: '40px',
			lineHeight: '40px',
			minWidth: '140px',
			padding: '0px 10px',
			textAlign: 'right',
		},
	});

/**
 * 目標設定部品公開プロパティー定義
 */
export interface ISkillMapTargetSetProp {
	/**
	 * 目標設定表示用なパラメータ
	 */
	param: ITargetSetParam;

	/**
	 * ダイアログ開くフラグ
	 */
	open: boolean;

	/**
	 * ダイアログ閉じる時、実行するな方法
	 */
	onClose: (val: any) => void;
}

/**
 * 目標設定部品内部状態定義
 */
interface IState {
	/**
	 * ダイアログ開くフラグ
	 */
	open: boolean;

	/**
	 * 目標設定表示用なパラメータ
	 */
	param: ITargetSetParam;

	/**
	 * loading
	 */
	loading: boolean;
}

class SkillMapTargetSet extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);
		/**
		 * 状態初期化
		 */
		this.state = {
			loading: false,
			open: false,
			param: {
				adminView: false,
				cellLabel: '',
				cmId: '',
				cmcId: '',
				comment: '',
				target: 0,
				userId: '',
			},
		};
	}

	/**
	 * プロパティー変更
	 */
	public componentWillReceiveProps(newProps: any) {
		const para = { ...newProps.param };
		if (isNull(para.target)) {
			para.target = 0;
		}
		if (isNull(para.comment)) {
			para.comment = '';
		}
		this.setState({ open: newProps.open, param: para });
	}

	/**
	 * 部品レイアウトレンダリング
	 */
	public render() {
		const { classes } = this.props;
		let cellLabel = this.state.param.cellLabel;
		if (cellLabel && cellLabel.indexOf('レベル') !== -1) {
			cellLabel = cellLabel.replace(
				'レベル',
				i18n.t('レベル', {
					ns: 'force',
				})
			);
		}
		return (
			<div className={classes.root}>
				<Dialog open={this.state.open} onClose={this.handleClose}>
					<AppBar className={classes.appBar}>
						<Toolbar>
							<IconButton
								edge="start"
								color="inherit"
								onClick={this.handleClose}
								aria-label="close"
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" className={classes.title}>
								{i18n.t('SkillMapTargetSet_0001')}
							</Typography>
						</Toolbar>
					</AppBar>
					<DialogContent>
						<Paper className={classes.paper}>
							<div className={classes.baseRow}>
								<div className={classes.titleCol}>
									{i18n.t('SkillMapTargetSet_0002')}
								</div>
								<div
									className={`${classes.dataCol} ${
										classes.dataLabel
									}`}
								>
									{cellLabel}
								</div>
							</div>
							<div className={classes.baseRow}>
								<div className={classes.titleCol}>
									{i18n.t('SkillMapTargetSet_0003')}
								</div>
								<div
									className={`${classes.dataCol} ${
										classes.dataColBorder
									}`}
								>
									<Select
										input={
											<Input
												name="sdivision"
												id="sdivision"
											/>
										}
										id="sdivision"
										value={
											this.state.param.target === -1
												? 0
												: this.state.param.target
										}
										onChange={this.handleChange}
									>
										<MenuItem value={0}>
											{i18n.t('SkillMapTargetSet_0004')}
										</MenuItem>
										<MenuItem value={1}>
											{i18n.t('SkillMapTargetSet_0005')}
										</MenuItem>
									</Select>
								</div>
							</div>
						</Paper>
						<TextField
							margin="dense"
							id="name"
							label={i18n.t('SkillMapTargetSet_0006') + ': '}
							value={this.state.param.comment}
							onChange={this.handleTextChange}
							fullWidth={true}
							inputProps={{
								maxLength: 512,
							}}
						/>
					</DialogContent>
					<DialogActions
						style={{
							justifyContent: 'center',
							position: 'relative',
						}}
					>
						<Button
							onClick={this.handleSubmit}
							color="primary"
							variant="contained"
							disabled={this.state.loading}
						>
							{i18n.t('SkillMapTargetSet_0007')}
						</Button>
						{this.state.loading && (
							<CircularProgress
								size={24}
								className={classes.buttonProgress}
							/>
						)}
					</DialogActions>
				</Dialog>
			</div>
		);
	}

	/**
	 * 目標変更イベント
	 * @param event
	 */
	protected handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		const value: any = event.target.value;
		const tmp = { ...this.state.param };
		tmp.target = Number(value);
		this.setState({ param: tmp });
	};

	/**
	 * コメント入力イベント
	 * @param event
	 */
	protected handleTextChange = (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const tmp = { ...this.state.param };
		tmp.comment = event.target.value;
		this.setState({ param: tmp });
	};

	/**
	 * ダイアログ閉じるコールバック
	 */
	protected handleClose = () => {
		this.setState({ open: false });
		this.props.onClose({ submit: false });
	};

	/**
	 * 目標設定処理
	 */
	protected handleSubmit = () => {
		this.setState({ loading: true });
		// 目標設定処理
		const tmp = { ...this.state.param };
		if (tmp.target === -1) {
			tmp.target = 0;
		}
		this.setState({ param: tmp });
		this.props
			.updateTargetInfo(this.props.token, this.state.param)
			.then(() => {
				// 目標とコメントを設定する後で画面格納のデータを更新する。
				this.setState({ loading: false, open: false });
				this.props.onClose({ param: this.state.param, submit: true });
			});
	};
}

const mapStateToProps = (state: IRootState) => ({
	token: state.session.token,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	/**
	 * 目標設定処理
	 */
	updateTargetInfo: (token: string, arg: ITargetSetParam) => {
		const s = SkillMapScenarioFactory.setTargetInfo(dispatch, token);
		return s.run(arg);
	},
});

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & ISkillMapTargetSetProp;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(SkillMapTargetSet);

const Styled = withStyles(styles)(Connected);
const Export: React.ComponentType<ISkillMapTargetSetProp> = Styled;

export default Export;



// WEBPACK FOOTER //
// ./src/components/SkillMapTargetSet.tsx